import { z } from 'zod';

/**
 * The only reference shape a task assignee may take. ONE definition for the
 * gate: the contract edge, the create service check, and the review edit all
 * consume this — two hand-mirrored copies of the pattern would drift when
 * only one is retuned.
 */
export const PRACTITIONER_REFERENCE_REGEX =
  /^Practitioner\/[A-Za-z0-9.-]{1,64}$/;

/**
 * The task-specific WRITE contract for the review edit flow. The generic
 * mini-apps edit endpoint carries these opaquely in `extras` (the shared
 * `ReviewEdit` stays coding-only — framework code never learns task fields);
 * the clinical-tasks agent validates against this schema server-side, and the
 * edit sheet builds its payload from the same definition.
 *
 * Semantics per field: `undefined`/omitted = leave untouched; explicit `null`
 * clears (due date only — priority/owner are never cleared).
 */
export const clinicalTaskEditExtrasSchema = z.object({
  /** ISO date (YYYY-MM-DD); null removes the due date. */
  dueDate: z.string().nullable().optional(),
  /** Assignee, `Practitioner/<id>`. */
  ownerReference: z.string().nullable().optional(),
  /** FHIR request-priority code (see CLINICAL_TASK_PRIORITIES). */
  priority: z.string().nullable().optional(),
  /** Lifecycle status transition (see CLINICAL_TASK_STATUSES); omitted =
   *  status untouched. Folds into intent + review tag server-side. */
  status: z.string().optional(),
});

export type ClinicalTaskEditExtras = z.infer<
  typeof clinicalTaskEditExtrasSchema
>;
